const facilities = [
  {
    name: "O'Fallon Post Office — Bryan Road",
    address: "2380 Bryan Valley Commercial Dr, O'Fallon, MO 63368",
    hours: "Mon–Fri 8:30AM–5:00PM, Sat 9:00AM–12:00PM",
    services: ["Passport photos", "Acceptance agent"],
    note: "Primary O'Fallon passport acceptance location. Call ahead to verify agent availability.",
  },
  {
    name: "St. Peters Post Office",
    address: "20 Jungermann Rd, St. Peters, MO 63376",
    hours: "Mon–Fri 8:30AM–5:00PM, Sat 9:00AM–12:00PM",
    services: ["Passport photos", "Acceptance agent"],
    note: "St. Peters location convenient for eastern O'Fallon and Lake Saint Louis residents.",
  },
  {
    name: "Wentzville Post Office",
    address: "1440 Wentzville Pkwy, Wentzville, MO 63385",
    hours: "Mon–Fri 8:30AM–5:00PM",
    services: ["Passport acceptance", "Passport photos"],
    note: "Good option for western O'Fallon and Wentzville area residents.",
  },
  {
    name: "St. Charles City Clerk Office",
    address: "200 N 2nd St, St. Charles, MO 63301",
    hours: "Mon–Fri 8:00AM–5:00PM",
    services: ["Passport acceptance", "Government ID accepted"],
    note: "St. Charles County official acceptance for residents seeking a government-office alternative to the post office.",
  },
];

export default function OFallonAcceptanceFacilitiesSection() {
  return (
    <section id="acceptance-facilities" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Acceptance Facilities</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Passport Acceptance Locations Near O&apos;Fallon
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base">
            First-time applicants and some renewals require an in-person acceptance step at an authorized facility. Here are the closest locations for O&apos;Fallon and St. Charles County residents.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {facilities.map((f, i) => (
            <div key={i} className="bg-white border border-gray-200 rounded-lg p-6">
              <h3 className="font-bold text-[#1A365D] text-base mb-1">{f.name}</h3>
              <p className="text-gray-500 text-sm mb-1 flex items-start gap-1.5">
                <i className="ri-map-pin-line text-[#F6C344] mt-0.5 flex-shrink-0"></i>{f.address}
              </p>
              <p className="text-gray-400 text-xs mb-3 flex items-start gap-1.5">
                <i className="ri-time-line text-[#F6C344] mt-0.5 flex-shrink-0"></i>{f.hours}
              </p>
              <div className="flex flex-wrap gap-2 mb-3">
                {f.services.map((s, j) => (
                  <span key={j} className="bg-[#EEF2F8] text-[#1A365D] text-xs font-semibold px-2.5 py-1 rounded-full">{s}</span>
                ))}
              </div>
              <p className="text-gray-400 text-xs italic">{f.note}</p>
            </div>
          ))}
        </div>

        <div className="mt-10 bg-[#1A365D] rounded-lg p-6 text-center">
          <p className="text-white text-sm mb-3">
            <strong className="text-[#F6C344]">Renewals:</strong> Most passport renewals do NOT require an in-person visit to an acceptance facility. Simply mail your documents directly to us.
          </p>
          <a href="https://fastpassportcenter.com/checkout/" className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-6 py-3 rounded-md transition-all whitespace-nowrap">
            Start Online — No Office Visit Required <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}